import React, { Component } from 'react'
//import MaterialIcon, {colorPalette} from 'material-icons-react';
//import Navbar from 'react-bootstrap/Navbar'
import HomeIcon from '@material-ui/icons/Home';
import MoodIcon from '@material-ui/icons/Mood';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import RoomServiceIcon from '@material-ui/icons/RoomService';
import MenuIcon from '@material-ui/icons/Menu';

export default class Navbar extends Component {
  
  state={
    menu:true,
    divname:"nav-item",
  }
  navbarexpand=()=>{
    console.log('click')
    this.state.menu?
    this.setState({
      menu:false,    
      divname:"nav-item-show",
    })
    :
    this.setState({
      menu:true,
      divname:"nav-item",
    })
    
  }

    render() {
        return (
            <nav className="navbar">
                  <div className="navbar-menu">
                    <a className="navbar-brand">Nitin kumar</a>
                    <div className="toggler-Hamburger">
                      <a className="icon-button-ham" onClick={this.navbarexpand}><MenuIcon/></a>
                    </div>
                    <div>
                      <div id="menu" className={this.state.divname}>
                        <div className="nav-item-row">
                            <div>
                              <a href="#home-page" className="icon-button"><HomeIcon/>
                              <span className="tooltiptext">Home</span></a>
                            </div>
                        </div>
                        <div className="nav-item-row">
                          <div>
                            <a href="#about-page" className="icon-button"><MoodIcon/>
                            <span className="tooltiptext">About me</span>
                            </a>
                          </div>
                        </div>
                        <div className="nav-item-row">
                          <div>
                            <a href="#services-page" className="icon-button"><RoomServiceIcon/>
                              <span className="tooltiptext">Services</span>
                            </a>

                          </div>
                        </div>
                        <div className="nav-item-row">
                          <div>
                            <a href="https://drive.google.com/file/d/1fJ9Msa5AvDSc3di4aq7jSYpd7aN1y0Iy/view?usp=sharing" 
                            target="_blank" className="icon-button"><ReceiptIcon/>
                            <span className="tooltiptext">My Resume</span>
                            </a>
                          </div>
                        </div>
                        <div className="nav-item-row">
                          <div>
                            <a href="#contact-page" className="icon-button"><PhoneInTalkIcon/>
                            <span className="tooltiptext">Contact us</span>
                            </a>
                          </div> 
                      </div>                   
                      </div>
                    </div>
                  </div>
                </nav>
        )
    }
}
